<template>
  <div class="container">
    <div :class="{ banner: true, showBtn: btnFlage }">
      <div class="swiper-container bannerSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in bannerList"
            :key="index + 'qua'"
          >
            <img :src="item.photo" width="100%" height="auto" />
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-pagination"></div>
        <!--分页器。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>

    <!-- 第一部分，新闻主体 -->
    <div class="news_page_one_side">
      <div
        class="news_one_side_item"
        v-for="(item, index) in newsList"
        :key="'news' + index"
        @click="getMore(item)"
      >
        <div class="news_item_img">
          <img :src="item.cover" width="auto" height="100%" />
        </div>
        <div class="news_item_contnet">
          <div class="news_item_title">
            {{ item.title }}
          </div>
          <div class="news_item_line"></div>
          <div class="news_item_content">
            {{ item.introduction | ellInt }}
          </div>
          <div class="news_item_time">
            {{ item.createTime }}
          </div>
          <div class="news_item_more">查看更多</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import { getNewsList, getBanner } from '@/api/apiCenter'
export default {
  data() {
    return {
      bannerList: [],
      btnFlage: false,
      newsList: [],
    }
  },
  methods: {
    init() {
      let that = this
      getBanner('news').then((res) => {
        that.bannerList = res.data.data
        this.$nextTick(() => {
          that.initBannerSwiper()
        })
        this.getNews()
      })
    },
    initBannerSwiper() {
      this.bannerSwiper = new Swiper('.bannerSwiper', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        freeMode: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    },
    getNews() {
      getNewsList().then((res) => {
        this.newsList = res.data.data
      })
    },
    getMore(row) {
      let id = row.id
      this.$router.push({ path: '/newsOne/index', query: { id: id } })
    },
  },
  mounted() {
    this.init()
  },
  filters: {
    ellInt(value) {
      if (!value) return ''
      if (value.length > 200) {
        return value.slice(0, 200) + '...'
      }
      return value
    },
    ellTitle(value) {
      if (!value) return ''
      if (value.length > 15) {
        return value.slice(0, 15) + '...'
      }
      return value
    },
  },
}
</script>
<style scoped>
/* 轮播部分 */
.banner .swiper-container {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper .swiper-slide {
  width: 100%;
  height: auto;
}
.banner .swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: rgba(161, 161, 161, 0.5); /* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px; /* 设置按钮大小 */
  --swiper-pagination-color: rgba(255, 255, 255, 0.5); /* 两种都可以 */
  --swiper-pagination-size: 50px; /* 设置按钮大小 */
}

/* 第一部分，新闻主体 */
.news_page_one_side {
  width: 70%;
  height: auto;
  padding-bottom: 335px;
  margin: 78px auto 0 auto;
}
.news_one_side_item {
  width: 100%;
  height: 354px;
  margin-bottom: 50px;
  display: flex;
  justify-content: left;
  cursor: pointer;
  padding: 20px;
}
.news_one_side_item:hover {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 3px 20px 0px rgba(109, 210, 255, 0.16);
}
.news_item_img {
  height: 100%;
  width: auto;
  display: inline-block;
  margin-right: 30px;
}
.news_item_contnet {
  width: auto;
  height: 354px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.news_item_title {
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #000000;
  line-height: 26px;
  letter-spacing: 2.38px;
}
.news_item_line {
  width: 50px;
  height: 4px;
  background: #2468f2;
}
.news_item_content {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #4f5768;
  line-height: 25px;
  letter-spacing: 0.4px;
}
.news_item_time {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #c9c9c9;
  line-height: 25px;
  letter-spacing: 0.4px;
}
.news_item_more {
  width: 206px;
  height: 54px;
  border: 1px solid #2468f2;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2468f2;
  font-size: 16px;
}
</style>
